import { Controller } from "@hotwired/stimulus"

// Manages add/remove of steps and cards in the workflow template editor
export default class extends Controller {
  static targets = ["stepsContainer", "cardsContainer"]

  addStep(event) {
    event.preventDefault()
    const container = event.target.closest("[data-card-index]")
      ? event.target.closest("[data-card-index]").querySelector("[data-step-list]")
      : this.stepsContainerTarget

    const items = container.querySelectorAll("[data-step-item]")
    const nextIndex = items.length

    const cardIndex = event.target.closest("[data-card-index]")?.dataset.cardIndex
    const namePrefix = cardIndex !== undefined
      ? `project_workflow[cards][${cardIndex}][steps][${nextIndex}]`
      : `project_workflow[steps][${nextIndex}]`

    const row = document.createElement("div")
    row.dataset.stepItem = ""
    row.className = "flex items-center gap-2"
    row.innerHTML = `
      <span class="text-xs text-gray-400 w-5 text-right flex-shrink-0">${nextIndex + 1}.</span>
      <input type="text"
             name="${namePrefix}[description]"
             class="flex-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
             placeholder="Step description"
             required>
      <button type="button" data-action="click->workflow-template-editor#removeStep" class="text-gray-400 hover:text-red-500 p-1 flex-shrink-0">
        <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
      </button>
    `
    container.appendChild(row)
    row.querySelector("input").focus()
  }

  removeStep(event) {
    event.preventDefault()
    const item = event.target.closest("[data-step-item]")
    const container = item.parentElement
    item.remove()
    this.renumberSteps(container)
  }

  addCard(event) {
    event.preventDefault()
    const container = this.cardsContainerTarget
    const items = container.querySelectorAll("[data-card-index]")
    const nextIndex = items.length

    const card = document.createElement("div")
    card.dataset.cardIndex = nextIndex
    card.className = "bg-gray-50 rounded-lg border border-gray-200 p-4 space-y-3"
    card.innerHTML = `
      <div class="flex items-center justify-between">
        <span class="text-sm font-medium text-gray-700">Card ${nextIndex + 1}</span>
        <button type="button" data-action="click->workflow-template-editor#removeCard" class="text-gray-400 hover:text-red-500 text-xs">Remove card</button>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 mb-1">Card name</label>
        <input type="text"
               name="project_workflow[cards][${nextIndex}][name]"
               class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
               placeholder="Card name"
               required>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 mb-1">Description (optional)</label>
        <input type="text"
               name="project_workflow[cards][${nextIndex}][description]"
               class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
               placeholder="Card description">
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 mb-1">Steps</label>
        <div data-step-list class="space-y-2"></div>
        <button type="button"
                data-action="click->workflow-template-editor#addStep"
                class="mt-2 text-xs text-blue-600 hover:text-blue-800">
          + Add step
        </button>
      </div>
    `
    container.appendChild(card)
    card.querySelector("input").focus()
  }

  removeCard(event) {
    event.preventDefault()
    const card = event.target.closest("[data-card-index]")
    card.remove()
    this.renumberCards()
  }

  renumberSteps(container) {
    container.querySelectorAll("[data-step-item]").forEach((item, i) => {
      const label = item.querySelector("span")
      if (label) label.textContent = `${i + 1}.`

      const cardEl = item.closest("[data-card-index]")
      const cardIndex = cardEl?.dataset.cardIndex
      const input = item.querySelector("input")
      if (input) {
        input.name = cardIndex !== undefined
          ? `project_workflow[cards][${cardIndex}][steps][${i}][description]`
          : `project_workflow[steps][${i}][description]`
      }
    })
  }

  renumberCards() {
    this.cardsContainerTarget.querySelectorAll("[data-card-index]").forEach((card, i) => {
      card.dataset.cardIndex = i
      const title = card.querySelector(".text-sm.font-medium")
      if (title) title.textContent = `Card ${i + 1}`

      const nameInput = card.querySelector(`input[name*="[name]"]`)
      if (nameInput) nameInput.name = `project_workflow[cards][${i}][name]`

      const descInput = card.querySelector(`input[name*="[description]"]:not([name*="[steps]"])`)
      if (descInput) descInput.name = `project_workflow[cards][${i}][description]`

      card.querySelectorAll("[data-step-item]").forEach((step, j) => {
        const input = step.querySelector("input")
        if (input) input.name = `project_workflow[cards][${i}][steps][${j}][description]`
      })
    })
  }
}
